import { type InstallationProfile } from '@common/types/api';

interface DeviceType {
  readonly id: number;
  readonly name: string;
}

export const createDeviceTypeFromResponse = (apiDeviceType: InstallationProfile): DeviceType => ({
  id: apiDeviceType.id,
  name: apiDeviceType.name,
});

export default DeviceType;
